const initialState = {
    path: '/contracts'
}

const appReducers = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PATH':
            return {
                ...state,
                path: action.path
            }
        default:
            return state
    }
}

export default appReducers


// WEBPACK FOOTER //
// ./src/components/App/AppReducers.js